import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, firstValueFrom, map, Observable, of } from 'rxjs';
import { DTO, Types } from 'shared-lib';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isLoggedIn = signal<boolean>(false);
  user = signal<DTO.JwtDTO | undefined>(undefined);
  userInfo: DTO.UserDTO | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService
  ) {}

  login(authDetails: DTO.AuthInDTO): Observable<boolean> {
    return this.http.post<DTO.AuthOutDTO>('auth', authDetails).pipe(
      map((response) => {
        localStorage.setItem('JWT_Token', response.accessToken);
        this.init();
        this.router.navigate(['/']);
        return true;
      }),
      catchError((error) => {
        console.error('error:', error);
        this.isLoggedIn.set(false);
        this.user.set(undefined);
        return of(false);
      })
    );
  }

  async getUserInfo(id?: number): Promise<DTO.UserDTO | null> {
    const accessToken = localStorage.getItem('JWT_Token');
  
    if (!accessToken) {
      return null;
    }
  
    try {
      const path = id ? `userAccount/other-user/${id}` : 'userAccount';
      return await firstValueFrom(
        this.http.get<DTO.UserDTO>(path).pipe(
          map((response) => response),
          catchError((error) => {
            return of(null);
          })
        )
      );
    } catch {
      return null;
    }
  }

  getUserData(){
    return this.userInfo;
  }
  
  getUser(){
    return this.user()
  }

  async init() {
    const accessToken = localStorage.getItem('JWT_Token');
    const userBase64 = accessToken?.split('.')?.[1];
    if (accessToken && userBase64) {
      this.isLoggedIn.set(true);
      this.user.set(JSON.parse(atob(userBase64)));
      this.userInfo = await this.getUserInfo();
    }
  }

  logout(): void {
    localStorage.removeItem('JWT_Token');
    this.isLoggedIn.set(false);
    this.user.set(undefined);
    this.router.navigate(['/login']);
    this.toastService.add(
      `Você realizou seu logout (saida ou desconexão) com sucesso!`,
      30000,
      'success'
    );
  }

  isAuthenticated(): WritableSignal<boolean> {
    return this.isLoggedIn;
  }

  isAllowed(allowedRoles: Types.ERole[]) {
    for (const role of allowedRoles) {
      if (this.user()?.roles.includes(role as Types.ERole)) {
        return true;
      }
    }
    return false;
  }
}
